export default __webpack_public_path__ + "static/media/27.da2ae556.png";